import React from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import * as actions from '../../actions/index';
import icons from '../../data/icons';

import './MediaList.css';

class MediaList extends React.Component {
  clickMedia(media) {
	  // console.log('opening media', media)


  	  media && this.props.setModal(media);

	  // const electron = window.require && window.require('electron');
	  // const ipcRenderer = electron && electron.ipcRenderer;
	  // if(ipcRenderer) {
	  //   //window.location.href = media.content
	  //   if(true || media.type === 'pdf') {
	  //     console.log(this)
	  //     this.props.setModal(media);
	  //   } else {
	  //     media && ipcRenderer.send('open-external-url', media.content);
	  //   }
	  // } else {
	  //   media && media.content && window.open(media.content);
	  // }
  }
  render() {
  	return (
	  <section className={"media-box " + (this.props.fixToBottom ? 'fix-to-bottom' : '')}>
	    <section className="media-row-header">Media</section>
	    {this.props.media.map(media => (
	      <section className="media-row" key={media.content} onClick={this.clickMedia.bind(this, media)}>
	        <span className="media-link">
	          <span>OPEN</span>
	          <img alt="" className="reference__openIcon" src={icons.open.svg} />
	        </span>
	        <label>{media.title}</label>
	      </section>
	    ))}
	  </section>
	)
  }
};

function mapDispatchToProps(dispatch) {
  return {
    setModal: (media) => {
      dispatch(actions.setModal(media));
    },
  };
}

MediaList.propTypes = {
	id: propTypes.string,
	fixToBottom: propTypes.bool,
	media: propTypes.array.isRequired,
	setModal: propTypes.func,
};

export default connect(null, mapDispatchToProps)(MediaList);



// WEBPACK FOOTER //
// ./src/components/MediaList/MediaList.js